import { Snackbar, Alert, Button } from '@mui/material';

export const SnackbarAlert = ({ open, onClose, severity, message, action }) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={action ? 8000 : 6000} // Mais tempo se tem ação
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            action={action && (
                <Button 
                    color="inherit" 
                    size="small" 
                    onClick={() => {
                        action.onClick?.();
                        onClose?.();
                    }}
                    sx={{ color: 'white', fontWeight: 500 }}
                >
                    {action.label}
                </Button>
            )}
            sx={{
                '& .MuiAlert-root': {
                    fontSize: '0.875rem',
                    alignItems: 'center',
                },
            }}
        >
            <Alert
                onClose={onClose}
                severity={severity}
                action={action && (
                    <Button 
                        color="inherit" 
                        size="small" 
                        onClick={() => {
                            action.onClick?.();
                            onClose?.();
                        }}
                        sx={{ 
                            color: severity === 'success' ? 'success.main' : 'inherit',
                            fontWeight: 500,
                            textTransform: 'none'
                        }}
                    >
                        {action.label}
                    </Button>
                )}
                sx={(theme) => ({
                    width: '100%',
                    backgroundColor: theme.palette.background.paper,
                    color:
                        theme.palette[severity]?.main ||
                        theme.palette.text.primary,
                    border: `1px solid ${
                        theme.palette[severity]?.main || theme.palette.divider
                    }`,
                    '& .MuiAlert-icon': {
                        color:
                            theme.palette[severity]?.main ||
                            theme.palette.text.primary,
                    },
                    boxShadow: theme.shadows[3],
                })}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};
